import type {PropsFacade, ViewConfig} from './types';

export const VIEW_CONFIG = '__view_config';

export function getViewConfig<T>(facade: T): ViewConfig<T> {
  return (facade as PropsFacade<T>)[VIEW_CONFIG] as ViewConfig<T>;
}
